// HomePage.jsx

// Dependencies
import { useEffect, useState } from 'react';

// Components
import Drafts from '@/components/data/common/drafts/Drafts';
import LoadingOverlay from '@/components/common/LoadingOverlay';

// Services
import { getDrafts} from '@/services/schedulingService';

// Styling
import { homeCss } from '@digital_monorepo/styling';

const DraftsPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const draftsReport = await getDrafts(false, false);
        setData(draftsReport);
      } catch (error) {
        console.error('Error fetching unengaged professionals data:', error);
        setData([
          {
            AllocationID: 'null',
            ProfessionalID: 'null',
            ProfessionalName: 'null',
            FunctionLevel: 'null',
            FunctionName: 'null',
            Office: 'null',
            ProfessionalRC: 'null',
            ProfessionalNotes: '',
            EngagementID: 'null',
            EngagementName: 'null',
            Client: 'null',
            ClientCode: 'null',
            Type: 'null',
            Status: 'null',
            Manager: '',
            EngagementRC: 'null',
            EngagementNotes: '',
            StartDate: 'null',
            Hours: '0'
          }
        ]);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  return (
    <div className={homeCss.container}>
      {loading && <LoadingOverlay />}
      <div className={homeCss.mainContent}>
        {data && <Drafts data={data}/>}
      </div>
    </div>
  );
};

export default DraftsPage;
